// extracted by mini-css-extract-plugin
export default {"submit":"lUAwogzNZaTMfIsjQtWA","resetCard":"j1X7sTgirA4xmchldc6s","root":"qDlMAdoqGPcxKldjhbAI","image":"loTkBrp1s47bmVU3dIUD","button":"_G7SyqggHypZ90QM0RwW"};